import { Field } from 'services/http/bi-tool/field'
import { Query } from 'services/http/bi-tool/query'
import { WidgetVisualization } from 'services/http/bi-tool/widget'

import {
  SocialNumbersVisualizationFields,
  SocialNumbersVisualizationOptions,
} from '../types'

export const generateSocialNumbersOptions = (
  options: SocialNumbersVisualizationOptions,
  query: Query,
  fields: Field[]
): SocialNumbersVisualizationOptions => {
  let result = options

  query.groups?.forEach((group) => {
    result = {
      ...result,
      fields: {
        ...result.fields,
        [group.field]: group.field as string,
      },
    }
  })

  return result
}

export const generateSocialNumbersVisualization = (
  fields: Field[]
): WidgetVisualization => {
  const options = fields.reduce((prev, next) => {
    prev[next.field] = next.field

    return prev
  }, {} as SocialNumbersVisualizationFields)

  return {
    type: 'social-numbers',
    options: {
      fields: {
        totalTweetCount: options['totalTweetCount'],
        totalOriginTweetCount: options['totalOriginTweetCount'],
        totalRetweetCount: options['totalRetweetCount'],
        totalFollowersCountOfTweetedAccounts:
          options['totalFollowersCountOfTweetedAccounts'],
        uniqueAccountCount: options['uniqueAccountCount'],
        totalImpressionCount: options['totalImpressionCount'],
        youtubecount: options['youtubecount'],
        newspapercount: options['newspapercount'],
        instagramcount: options['instagramcount'],
        redditcount: options['redditcount'],
      },
    },
  }
}
